import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { InviteInput, InvitePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { useLocale } from 'next-intl';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = InviteInput;
type TData = InvitePayload;

export const useInviteMember = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();
  useLocale;

  const graphql = gql`
    mutation memberInvite($input: InviteInput!) {
      memberInvite(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
